import { PageNames } from '../constants';

export default {
  content: {
    name: PageNames.MANAGE_CONTENT_PAGE,
    path: '/content',
  },
  permissions: {
    name: PageNames.MANAGE_PERMISSIONS_PAGE,
    path: '/permissions',
  },
  facilities: {
    name: PageNames.FACILITIES_PAGE,
    path: '/facilities',
  },
  users: {
    name: PageNames.USERS_ROOT,
    path: '/users',
  },
  info: {
    name: PageNames.DEVICE_INFO_PAGE,
    path: '/info',
  },
  settings: {
    name: PageNames.DEVICE_SETTINGS_PAGE,
    path: '/settings',
  },
};
